<template>
  <div class="container graybg">
    <div class="navigation-bar">
      <div class="navigation-bar-txt">
        <span><router-link to="/">{{ t('menu.home') }}</router-link></span>
        <span>{{ t('servicechildmenu.service1') }}</span>
       
      </div>
    </div>
    <div class="new-list-bar">
      <h2 class="title">{{ t('pasture.moduleA.title') }}</h2>
      <ul class="ul-list">
            <li v-for="item in t('pasture.moduleA.list').split(';')" :key="item">
              <p><i class="li-icon"></i><span class="span-txt">{{ item.split(':')[0]}}</span></p>
              <p style="text-indent: 30px;">{{ item.split(':')[1]}}</p>
            </li>
      </ul>
      <div class="news-list">
        <img width="1440" src="../../assets/images/banner-7.png" />
      </div>
    </div>
    <div class="new-list-bar">
      <p class="subtitle">{{t('pasture.moduleB.desc1')}}</p>
      <div class="news-list">
        <img width="1440" src="../../assets/images/banner-8.png" />
      </div>
    </div>
    <div class="new-list-bar">
      <p class="subtitle">{{t('pasture.moduleB.desc2')}}</p>
      <div class="news-list">
        <img width="1440" src="../../assets/images/zh3.png" />
      </div>
    </div>
    <div class="new-list-bar">
      <p class="subtitle">{{t('pasture.moduleB.desc3')}}</p>
      <h2 class="title title1">{{ t('pasture.moduleB.title') }}</h2>
      <ul class="contact-list">
        <li v-for="item in coreList" :key="item">
          <span class="span-icon-box"><img :src="item.qrcode" /></span>
          <span class="span-name whitespace-pre-line">{{ item.name }}</span>
          <span class="span-details whitespace-pre-line">{{ item.details }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import { watch,computed} from "vue";
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
const coreList = computed(() => [
  {
    name:  t('ourserveA.coreListname.name1'),
    details: t('ourserveA.coreListDetails.details1'),
    qrcode: require("../../assets/images/zh4.svg"),
  },
  {
    name:  t('ourserveA.coreListname.name2'),
    details: t('ourserveA.coreListDetails.details2'),
    qrcode: require("../../assets/images/zh5.svg"),
  },
  {
    name:  t('ourserveA.coreListname.name3'),
    details: t('ourserveA.coreListDetails.details3'),
    qrcode: require("../../assets/images/zh6.svg"),
  },
  {
    name:  t('ourserveA.coreListname.name4'),
    details: t('ourserveA.coreListDetails.details4'),
    qrcode: require("../../assets/images/zh7.svg"),
  },
  {
    name:  t('ourserveA.coreListname.name5'),
    details: t('ourserveA.coreListDetails.details5'),
    qrcode: require("../../assets/images/zh8.svg"),
  },
  {
    name:  t('ourserveA.coreListname.name6'),
    details: t('ourserveA.coreListDetails.details6'),
    qrcode: require("../../assets/images/zh9.svg"),
  }
])
// const coreListCn = ref([
//   {
//     name: 'High production efficiency',
//     details: 'Optimized cow flow, feeding systems,\n and milking operations to maximize \noutput and labor productivity.',
//     qrcode: require("../../assets/images/zh4.svg"),
//   },
//   {
//     name: 'Animal welfare first',
//     details: 'Designs based on cow behavior and\n physiological needs, reducing stress and \nsupporting consistent milk production.',
//     qrcode: require("../../assets/images/zh5.svg"),
//   },
//   {
//     name: 'Strong biosecurity',
//     details: 'Clear zoning, controlled access, \nand one-way workflows to minimize disease \nrisks and protect herd health.',
//     qrcode: require("../../assets/images/zh6.svg"),
//   },
//   {
//     name: 'Smart & digital management',
//     details: 'Real-time monitoring, data collection,\n and intelligent control systems \nto support informed decision-making。',
//     qrcode: require("../../assets/images/zh7.svg"),
//   },
//   {
//     name: 'Sustainable & compliant',
//     details: 'Environmentally responsible manure \nmanagement and resource recycling \nthat meet regulatory standards.',
//     qrcode: require("../../assets/images/zh8.svg"),
//   },
//   {
//     name: 'Flexible for future growth',
//     details: 'Modular layouts and expansion-ready designs\n that adapt to changing production needs.',
//     qrcode: require("../../assets/images/zh9.svg"),
//   }
// ])
// const coreListZh = ref([
//   {
//     name: '生产效率高',
//     details: '优化奶牛流量、饲养系统和挤奶操作\n以最大限度地提高产量和劳动生产率',
//     qrcode: require("../../assets/images/zh4.svg"),
//   },
//   {
//     name: '动物福利第一',
//     details: '基于奶牛行为和生理需求的设计\n减少压力并支持稳定的产奶量。',
//     qrcode: require("../../assets/images/zh5.svg"),
//   },
//   {
//     name: '强大的生物安全',
//     details: '清晰的分区、受控的访问和单向工作流程\n以最大限度地降低疾病风险并保护牛群健康。',
//     qrcode: require("../../assets/images/zh6.svg"),
//   },
//   {
//     name: '挤奶机销售',
//     details: '实时监控、数据收集和智能控制系统\n以支持明智的决策。',
//     qrcode: require("../../assets/images/zh7.svg"),
//   },
//   {
//     name: '可持续和合规',
//     details: '符合监管标准的环保粪肥管理和资源回收',
//     qrcode: require("../../assets/images/zh8.svg"),
//   },
//   {
//     name: '灵活适应未来增长',
//     details: '适应不断变化的生产需求的模块化布局和可扩展设计。',
//     qrcode: require("../../assets/images/zh9.svg"),
//   }
// ])
// const coreList = ref([])
watch(locale, (newValue) => {
  if (newValue === 'en') {
    // coreList.value = coreListCn.value
    console.log('当前语言为英文0')
  } else if (newValue === 'zh') {
    console.log('当前语言为中文0')
    // coreList.value  = coreListZh.value
  }
}, { immediate: true })

</script>
<style lang="scss" scoped>
.new-list-bar{
  padding-top:30px;
  padding-bottom:0px;
  .title1{
    padding: 10px 0px 30px 0px;
  }
  .contact-list {
    padding:0px 0px 50px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    li {
      padding-top: 40px;
      display: flex;
      flex-direction: column;
      width: 412px;
      height: 240px;
      border-radius: 8px;
      background: #FFFFFF;
      text-align: center;

      span {
        display: block;
      }

      .span-icon-box {
        margin: 0 auto;
        width: 100px;
        height: 100px;
        border-radius: 15px;
        // border: 1px solid vars.$base-color;
        img {
          width: 80px;
          height: 80px;
          margin-top: 30px;
        }
      }

      .span-name {
        margin-top: 16px;
        font-size: 20px;
        font-weight: bold;
      }

      .span-details {
        margin-top: 6px;
        font-size: 16px;
      }
    }

  }
  .ul-list {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      li {
        display: flex;
        flex-direction: column;
        padding: 10px 0px;
        p{
          display: flex;
          flex-direction:row;
        .li-icon {
          display: block;
          width: 24px;
          height: 24px;
          background: url('../../assets/images/li-icon.svg') no-repeat left 6px;
        }

        .span-txt {
          margin-left: 10px;
          flex: 1;
          display: block;
          line-height: 32px;
          font-size: 16px;
        }
        }
      }
    }
  .subtitle{
   margin-top:0px;
   text-align: left;
  }
}
.whitespace-pre-line {
  white-space: pre-line;
}
.news-list img{
  box-sizing:border-box;
  border: 2px solid #d9d9d9;
}
</style>